import type * as PIXI from 'pixi.js';
import type { Radius } from 'types';

export function drawRoundRect(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  width: number,
  height: number,
  rawRadius: Partial<Radius> | number,
  fill = '#fff',
  stroke = '#fff',
  imageShadow = true,
): void {
  let radius: Radius = { tl: 0, tr: 0, br: 0, bl: 0 };

  if (typeof rawRadius === 'number') {
    radius = { tl: rawRadius, tr: rawRadius, br: rawRadius, bl: rawRadius };
  } else {
    (Object.keys(rawRadius) as (keyof Radius)[]).forEach((side) => {
      if (rawRadius[side]) radius[side] = rawRadius[side] as number;
    });
  }

  ctx.beginPath();
  ctx.moveTo(x + radius.tl, y);
  ctx.lineTo(x + width - radius.tr, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
  ctx.lineTo(x + width, y + height - radius.br);
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
  ctx.lineTo(x + radius.bl, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
  ctx.lineTo(x, y + radius.tl);
  ctx.quadraticCurveTo(x, y, x + radius.tl, y);
  ctx.closePath();

  // https://stackoverflow.com/questions/13470101/getting-single-shadow-for-fill-and-stroke-on-html-canvas
  if (imageShadow) {
    ctx.shadowColor = 'rgba(0,0,0,0.3)';
    ctx.shadowBlur = window.devicePixelRatio * 15;
  }

  ctx.fillStyle = fill;
  ctx.fill();

  ctx.lineWidth = 0;
  ctx.strokeStyle = stroke;
  ctx.stroke();

  if (imageShadow) {
    ctx.shadowColor = '';
    ctx.shadowBlur = 0;
    ctx.stroke();
    ctx.fill();
  }
}

export function drawPixiRoundRect(
  graphicsObject: PIXI.Graphics,
  x: number,
  y: number,
  width: number,
  height: number,
  rawRadius: Partial<Radius> | number,
  fill = 0xffffff,
  alpha = 1,
): void {
  let radius: Radius = { tl: 0, tr: 0, br: 0, bl: 0 };

  if (typeof rawRadius === 'number') {
    radius = { tl: rawRadius, tr: rawRadius, br: rawRadius, bl: rawRadius };
  } else {
    (Object.keys(rawRadius) as (keyof Radius)[]).forEach((side) => {
      if (rawRadius[side]) radius[side] = rawRadius[side] as number;
    });
  }

  graphicsObject.clear();
  graphicsObject.beginFill(fill, alpha);
  graphicsObject.moveTo(x + radius.tl, y);
  graphicsObject.lineTo(x + width - radius.tr, y);
  graphicsObject.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
  graphicsObject.lineTo(x + width, y + height - radius.br);
  graphicsObject.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
  graphicsObject.lineTo(x + radius.bl, y + height);
  graphicsObject.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
  graphicsObject.lineTo(x, y + radius.tl);
  graphicsObject.quadraticCurveTo(x, y, x + radius.tl, y);
  graphicsObject.closePath();
  graphicsObject.endFill();
}
